module.exports = __webpack_public_path__ + "media/images/athletes/500-58c790af2ec31105faee1b57db9adef1.png";